import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal/LegalPage";
import { TermsOfUse } from "@/components/legal/LegalModal";

export const Route = createFileRoute("/anvandarvillkor")({
  head: () => ({
    meta: [
      { title: "Användarvillkor | Sellavo" },
      { name: "description", content: "Läs användarvillkoren för Sellavo, annonser, AI-funktioner, auktioner och ditt ansvar som användare." },
      { property: "og:title", content: "Användarvillkor | Sellavo" },
      { property: "og:description", content: "Villkoren för att använda Sellavo och publicera annonser." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sellavo.com/anvandarvillkor" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/anvandarvillkor" }],
  }),
  component: () => (
    <LegalPage title="Användarvillkor" intro="Villkoren för att använda Sellavo, skapa annonser och sälja prylar på ett tryggt sätt.">
      <TermsOfUse />
    </LegalPage>
  ),
});